import React, { useEffect, useState } from 'react'
import { FaTasks } from 'react-icons/fa';
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import FollowUp from './FollowUp';
import NotAssignedTasks from '../HRDashboard/Components/NotAssignedTask';
import { getRole } from '../../../utils/cookies/cookies';
import TaskCard from '../HRDashboard/Components/TaskCard';
import FinalSubmitTask from '../AdminDashboard/FinalSubmit';

const StaffDashboard = () => {
    const role = getRole()
    const [tasksList, setTaskList] = useState([]);
    const [activeTab, setActiveTab] = useState('todaysTask');

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const fetchData = async () => {
        try {
            const response = await axiosAuthInstance.get('task/list',
                { sortPriority: true, limit: 30 }
            )
            if (response && response.status === 200) {
                setTaskList(response.data?.result?.docs)
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return (
        <>  
            <div className='w-full bg-white p-2 flex gap-5'>
                <div
                    className={`border-1 p-2 rounded-lg text-sm text-gray-600 hover:bg-orange-100 ${activeTab === 'todaysTask' ? 'bg-orange-100 text-orange-600' : 'hover:text-orange-600'
                        }`}
                    onClick={() => handleTabChange('todaysTask')}
                >
                    <button>Tasks</button>
                </div>

                <div
                    className={`border-1 p-2 rounded-lg text-sm text-gray-600 hover:bg-orange-100 ${activeTab === 'followUp' ? 'bg-orange-100 text-orange-600' : 'hover:text-orange-600'
                        }`}
                    onClick={() => handleTabChange('followUp')}
                >
                    <button>Follow Up</button>
                </div>

                <div
                    className={`border-1 p-2 rounded-lg text-sm text-gray-600 hover:bg-orange-100 ${activeTab === 'completed' ? 'bg-orange-100 text-orange-600' : 'hover:text-orange-600'
                        }`}
                    onClick={() => handleTabChange('completed')}
                >
                    <button>Final Submit</button>
                </div>
            </div>

            {activeTab === "todaysTask" &&
                <div className="p-6 space-y-6 max-w-7xl mx-auto">
                    <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                        <FaTasks className="h-5 w-5" />
                        My Tasks
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        <TaskCard tasksList={tasksList} reload={fetchData} />
                    </div>
                </div>
            }

            {activeTab === "followUp" &&
                <div className="max-w-6xl mx-auto p-6 space-y-8">
                    <FollowUp reload={fetchData} />
                </div>
            }

            {activeTab === "completed" &&
                <div className="p-6 space-y-6 max-w-7xl mx-auto">
                    <FinalSubmitTask />
                </div>
            }

            {role === "Team Leader" && <NotAssignedTasks reload={fetchData} />}
        </>
    )
}

export default StaffDashboard